export const getCloseWelcomeUrl = (state) => state.browsePage.closeWelcomeMessageUrl;

export default getCloseWelcomeUrl;
